/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import axios, { AxiosBasicCredentials, AxiosResponse } from 'axios';

const httpService = axios.create({});

export async function get<R = unknown>(
  url: string,
  config?: { auth?: AxiosBasicCredentials; withCredentials?: boolean }
): Promise<AxiosResponse<R, unknown>> {
  const headers = {
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  };
  return await httpService.get<unknown, AxiosResponse<R, unknown>>(url, {
    headers: headers,
    withCredentials: config?.withCredentials ?? true,
    auth: config?.auth
  });
}

export async function post<D = unknown, R = unknown>(
  url: string,
  data: D,
  auth?: AxiosBasicCredentials
): Promise<AxiosResponse<R, unknown>> {
  const headers = {
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  };
  return await httpService.post<unknown, Promise<AxiosResponse<R, unknown>>, D>(url, data, {
    headers: headers,
    withCredentials: true,
    auth
  });
}
